import {Tooltip} from "@mantine/core";
import {ExperimentalLink} from "../ExperimentalLink";
import IconChevronRight from "../../assets/arrow-right.svg?react";
import classes from "./LinkChip.module.css";

interface LinkChipProps {
    href: string;
    children: React.ReactNode;
    leftSection?: React.ReactNode;
    tooltip?: string;
    variant?: "filled" | "outlined";
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export function LinkChip({
    href,
    children,
    leftSection,
    tooltip,
    variant = "filled",
    onClick,
}: LinkChipProps) {
    const chip = (
        <ExperimentalLink
            href={href}
            className={`${classes.linkChip} ${classes[variant]}`}
            onClick={onClick}
        >
            {leftSection && (
                <span className={classes.leftSection} aria-hidden="true">
                    {leftSection}
                </span>
            )}
            {children}
            <span className={classes.chevron}>
                <IconChevronRight />
            </span>
        </ExperimentalLink>
    );

    if (!tooltip) return chip;
    return (
        <Tooltip label={tooltip} openDelay={200} withArrow>
            {chip}
        </Tooltip>
    );
}
